import { Typography } from "@material-ui/core";
import InputOptInMail from "./input/OptInMail";
import OptInSms from "./input/OptInSms";
import OptInTelefon from "./input/OptInTelefon";

const FormOptIn: React.FC = () => {
    return (
        <div>
            <div>
                <Typography variant='h4' color='textPrimary'>Wie dürfen wir Sie über Informationen benachrichtigen?</Typography>
                <Typography variant='caption' color='textPrimary' display='block' style={{ marginTop: 10 }}>
                    Hiermit willige ich ein, dass die RheinLand Versicherungs AG oder der für die RheinLand Versicherungs AG tätige Außendienst mich zu Marketingzwecken wie folgt kontaktieren darf:
                </Typography>
            </div>

            <div style={{ marginTop: 15 }}>
                <OptInTelefon />
            </div>
            <div>
                <OptInSms />
            </div>

            <div>
                <InputOptInMail />
            </div>

            <div style={{ marginTop: 15 }}>
                <Typography variant='caption' color='textPrimary'>
                    Meine erteilte Einwilligung kann ich jederzeit formfrei ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen, z.B. per E-Mail an betrieb@rheinland-versicherungen.de.
                </Typography>
            </div>
        </div>);
}

export default FormOptIn;